//import './App.css';
import React, {useState} from "react";
import Map from "./Map/Map";
import { Layers, TileLayer, VectorLayer, GeoserverLayer } from "./Layers";
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import { osm, vector, geoserver, xyz } from "./Source";
import { fromLonLat, get } from 'ol/proj';
import GeoJSON from 'ol/format/GeoJSON';
import { Controls, FullScreenControl, MousePositionControl, LayerHandler, Zoomer, ScaleBar } from "./Controls";
//import LayerSwitcher from "ol-layerswitcher";
import "ol-layerswitcher/dist/ol-layerswitcher.css";
import { format } from "ol/coordinate";
import "./App.css";
let styles = {
  'MultiPolygon': new Style({
    stroke: new Stroke({
      color: 'blue',
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.1)',
    }),
  }),
};
//const geojsonObject = { ... }; // see full geojson object in Github
//const geojsonObject2 = { ... }; // see full geojson object in Github
const App = () => {
  const [center, setCenter] = useState([/*-73.99, 40.75*/-103.75, 44.43]);
  const [zoom, setZoom] = useState(12);
  const [showLayer1, setShowLayer1] = useState(true);
  const [showLayer2, setShowLayer2] = useState(true);
  const [showLayer3, setShowLayer3] = useState(true);
  const [showLayer4, setShowLayer4] = useState(true);
return (
  <div>
    <div class="header">
	
		  <h2>Geoserver and OpenLayers (using React)</h2>
		  <h3><a href="https://github.com/adamstj">adamstj@GitHub</a></h3>
      
	</div>
    <div>
    <Map center={fromLonLat(center)} zoom={zoom}>
      <Layers>
        <TileLayer
          source={osm()}
          title='OSM'
          type='base'
          zIndex={0}
        />
        {/*<TileLayer
          source={google({ GoogleStringName: 'Google Physical',
                            params: {
                                      'type': 'google.maps.MapTypeId.TERRAIN',
                                      'numZoomLevels': '15',
                                      'sphericalMercator': 'true'
                            }
                          })}
          title='Google'
          type='base'
          zIndex={0}
                        />*/}
        <TileLayer
          source={xyz({ url: 'http://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
                        attributions: '.',
                        maxZoom: '15'
                      })}
          title='Google Terrain'
          type='base'
          zIndex={0}
        />
        {/* {showLayer1 && (
          <VectorLayer
            source={vector({ features: new GeoJSON().readFeatures(geojsonObject, { featureProjection: get('EPSG:3857') }) })}
            style={styles.MultiPolygon}
          />
        )}
        {showLayer2 && (
          <VectorLayer
            source={vector({ features: new GeoJSON().readFeatures(geojsonObject2, { featureProjection: get('EPSG:3857') }) })}
            style={styles.MultiPolygon}
          />
        )} */}
        {showLayer1 && (
          <GeoserverLayer
            source={geoserver({ url: 'http://localhost:8080/geoserver/wms',
                                params: {
                                          'LAYERS': 'sf:sfdem',
                                          //'styles': 'dem',
                                          //'transparent': 'true',
                                          //'format': 'image/jpeg',
                                        },
                                serverType: 'geoserver'})}
            title='Spearfish DEM'
            //style={styles.MultiPolygon}
          />)}
        {showLayer2 && (
          <GeoserverLayer
            source={geoserver({ url: 'http://localhost:8080/geoserver/wms',
                                params: {
                                          'LAYERS': 'sf:restricted',
                                        },
                                serverType: 'geoserver'})}
            title='Spearfish restricted'
            opacity={0.5}
            //style={styles.MultiPolygon}
          />)}
        {showLayer3 && (
          <GeoserverLayer
            source={geoserver({ url: 'http://localhost:8080/geoserver/wms',
                                params: {
                                          'LAYERS': 'sf:streams',
                                          //'styles': 'dem',
                                          //'transparent': 'true',
                                          //'format': 'image/jpeg',
                                        },
                                serverType: 'geoserver'})}
            title='Spearfish Streams'
            opacity={1}
            //style={styles.MultiPolygon}
          />)}
        {showLayer4 && (
          <GeoserverLayer
            source={geoserver({ url: 'http://localhost:8080/geoserver/wms',
            params: {
                      'LAYERS': 'sf:bugsites',
                    },
            serverType: 'geoserver'})}
            title='Spearfish bugsites'
            opacity={1}
            //style={styles.MultiPolygon}
          />)}
      </Layers>
      <Controls>
        <FullScreenControl />
        <MousePositionControl />
        <LayerHandler />
        <Zoomer />
        <ScaleBar />
      </Controls>
    </Map>
    {/*<div>
      <input
        type="checkbox"
        checked={showLayer1}
        onChange={event => setShowLayer1(event.target.checked)}
      /> Spearfish DEM
    </div>
    <div>
      <input
        type="checkbox"
        checked={showLayer2}
        onChange={event => setShowLayer2(event.target.checked)}
      /> Spearfish Streams
    </div>
    <div>
      <input
        type="checkbox"
        checked={showLayer3}
        onChange={event => setShowLayer3(event.target.checked)}
      /> Spearfish Bugsites
    </div>
    <div>
      <input
        type="checkbox"
        checked={showLayer4}
        onChange={event => setShowLayer4(event.target.checked)}
      /> Spearfish Restricted
                                      </div>*/}
  </div>
  </div>
    
  );
}

export default App;
